import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { EnvelopeSimpleIcon } from '@phosphor-icons/react';
import { useLinkEmail } from '@/api/rpc/hooks/accounts-receivable/useArRemittances';
import { EmailSearchCombobox } from './email-search-combobox';
import { T } from 'gt-react';

interface LinkEmailButtonProps {
  remittanceAdviceId: string;
}

export function LinkEmailButton({ remittanceAdviceId }: LinkEmailButtonProps) {
  const [showSearch, setShowSearch] = useState(false);
  const linkEmail = useLinkEmail();

  if (showSearch) {
    return (
      <EmailSearchCombobox
        onSelect={(inboundEmailId) => {
          linkEmail.mutate({ remittanceAdviceId, inboundEmailId });
          setShowSearch(false);
        }}
        onCancel={() => setShowSearch(false)}
      />
    );
  }

  return (
    <Button
      size="sm"
      variant="outline"
      onClick={() => setShowSearch(true)}
      disabled={linkEmail.isPending}
    >
      <EnvelopeSimpleIcon className="h-4 w-4 mr-1" />
      <T context="link email to remittance">Link Email</T>
    </Button>
  );
}
